import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=54d73650"
import script from "./Election.vue?vue&type=script&lang=ts"
export * from "./Election.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports